<script>
import { mapState } from "vuex";

import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";

import { Auth } from "aws-amplify";


/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      email: "admin@pichforest.com",
      password: "123456",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
          var redirectUrl = this.$route.query.redirect_link;
          if(redirectUrl){
            localStorage.setItem('redirectUrl', redirectUrl);
          }
          Auth.federatedSignIn({ provider: 'COGNITO'});
      }
    },
  }
};
</script>

<template>
  <div class="authentication-bg min-vh-100">
    <div class="bg-overlay bg-white"></div>
    <div class="container">
      <div class="d-flex justify-content-center flex-column min-vh-100">
        <div class="">
          <div class="card shadow-lg mx-auto py-4 px-5" style="width:480px">
            <div class="row">
              <div class="col-md-12">
                <div class="text-center py-5">
                  <div class="mb-4">
                    <router-link to="/" class="d-block auth-logo">
                      <img
                        src="@/assets/images/logo-dark.svg"
                        alt=""
                        height="62"
                        class="auth-logo-dark"
                      />
                    </router-link>
                  </div>
                  <div class="mb-5">
                    <h1 class="fw-bold mb-1">WELCOME BACK!</h1>
                    <p>Make sure that you have a account in microsoft 365 to login in our CRM.</p>
                  </div>
                
                  <div
                    v-if="notification.message"
                    :class="'alert ' + notification.type"
                  >
                    {{ notification.message }}
                  </div>
                  
                  <form  @submit.prevent="tryToLogIn">
                    
                    <div class="mb-3">
                      <button class="btn btn-primary w-100 mb-3" type="submit">
                        <div class="d-flex align-items-center">
                          <i class='bx bxl-microsoft bx-sm'></i>
                          <span class="mx-auto">Log in with microsoft 365</span>
                        </div>
                      </button>

                      <p class="fw-medium small"><i class='bx bxs-quote-left text-secondary'></i>Make today a productive day.<i class='bx bxs-quote-left bx-flip-horizontal text-secondary'></i></p>

                    </div>

                  </form>
                  <!-- end form -->

                </div>
              </div>
              <!-- end col -->
            </div>
            <!-- end row -->
          </div>
        </div>

        <div class="row">
          <div class="col-xl-12">
            <div class="text-center text-muted p-4">
              <p class="mb-0">
                &copy; {{ new Date().getFullYear() }} Peddlr Philippines.
              </p>
            </div>
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
    </div>
    <!-- end container -->
  </div>
  <!-- end authentication section -->
</template>

